import typeHints from './typeHints';

const attributes = {
  o_type: {
    friendly: 'Collectible Type',
    validations: {
      isRequired: true,
      maxLength: 45,
    },
  },
  o_maker: {
    friendly: 'Maker',
    validations: {
      maxLength: 45,
    },
  },
  o_medium: {
    friendly: 'Medium',
    validations: {
      maxLength: 45,
    },
  },
  o_dimensions: {
    friendly: 'Dimensions',
    validations: {
      maxLength: 45,
    },
  },
  o_inscriptions: {
    friendly: 'Inscriptions',
    validations: {
      maxLength: 45,
    },
  },
  o_signature: {
    friendly: 'Signature',
    validations: {
      maxLength: 45,
    },
  },
  o_year_produced: {
    friendly: 'Year Produced',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
    typeHint: typeHints.Date,
  },
  o_edition: {
    friendly: 'Edition',
    validations: {
      maxLength: 45,
    },
  },
  o_condition: {
    friendly: 'Condition',
    validations: {
      maxLength: 45,
    },
  },

  o_weight: {
    friendly: 'Weight',
    validations: {
      maxLength: 255,
    },
  },

  o_category: {
    friendly: 'Category',
    validations: {
      maxLength: 255,
    },
  },

};

export default attributes;

export const OtherRequiredAttributes = [{
  name: 'o_type',
  value: 'Unknown'
}];

export const OtherItemSearchAttributes = [];

export const OtherDefaultSplitAttribute = 'o_maker';

export const OtherOverviewAttributes = [
  'title',
  'o_type',
  'o_maker',
  'o_year_produced',
  'o_condition',
  'rarity',
  'market_value',
  'inventory_no',
  'tags',
];

export const OtherSpecificationAttributes = [
  'o_medium', 'o_edition', 'o_dimensions', 'o_inscriptions', 'o_signature',
];

export const OtherPurchaseAttributes = [
  'purchase_date',
  'purchase_price',
  'purchase_contact',
  'purchase_notes',
];

export const OtherDetailAttributes = [];

export const OtherDisplayAttributes = ['title', 'o_type', 'o_maker', 'o_medium', 'o_year_produced', 'tags'];

export const OtherSliderGalleryAttributes = {
  titleKey: 'o_type',
  subtitleKey: 'o_maker',
};



// WEBPACK FOOTER //
// ./src/config/otherDataAttributes.js